var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-8 pa-sm-4",attrs:{"flat":"","outlined":""}},[_c('v-card-title',{staticClass:"pa-0 mb-6",staticStyle:{"word-break":"keep-all"}},[_vm._t("title")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }